import script from "./PolicyGlobalSettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyGlobalSettingsModal.vue?vue&type=script&setup=true&lang=js"

import "./PolicyGlobalSettingsModal.vue?vue&type=style&index=0&id=a0e6391c&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0e6391c"]])

export default __exports__